import { withTranslation } from 'react-i18next';
import CatalogHeader from './CatalogHeader';

export default withTranslation()(CatalogHeader);
